module.exports = __webpack_public_path__ + "static/media/automa-logo-black.28615f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/automa-logo-black.png
// module id = 182
// module chunks = 0